module.exports = __webpack_public_path__ + "static/img/bystage_white_09.014c138b.svg";